<template>
  <div>
    <div class="my-5 container card_container">
      <div class="mb-5 titolo">
        <h3 class="text-green mt-5 text-center"><i class="fas fa-user"></i> Dati Visitatore</h3>
      </div>
      <b-row>
        <b-col sm>
					<label for="input-nome">Nome</label>
          <b-form-input
						id="input-nome"
            type="text"
            class="form-control form-control-solid"
            name="nome"
            value=""
            v-model="assistito.nome"
            :state="validationNome"
            style="text-transform: uppercase"></b-form-input>
        </b-col>
        <b-col sm>
					<label for="input-cognome">Cognome</label>
          <b-form-input
            type="text"
            class="form-control form-control-solid"
            name="cognome"
						id="input-cognome"
            value=""
            :state="validationCognome"
            v-model="assistito.cognome"
            style="text-transform: uppercase"></b-form-input>
        </b-col>
      </b-row>
			<b-row>
				<b-col sm class="mt-5">
					<label for="input-cf">Codice fiscale/Numero documento</label>
					<b-form-input
						type="text"
						class="form-control form-control-solid"
						name="cf"
						id="input-cf"
						value=""
						v-model="assistito.codiceFiscale"
						:state="validationCodiceFiscale"
						style="text-transform: uppercase"></b-form-input>
				</b-col>
				<b-col sm class="mb-7 mt-5">
					<label for="input-datanascita">Data di nascita</label>
					<date-picker
						id="input-datanascita"
						v-model="assistito.dataNascita"
						:disabled-date="disableDataNascita"
						format="DD/MM/YYYY"
						value-type="YYYY-MM-DD"
						style="width: 100%"></date-picker>
				</b-col>
			</b-row>
      <b-row>
        <b-col sm>
					<label for="select-provinciaresidenza">Provincia di residenza</label>
          <b-form-select id="select-provinciaresidenza" class="form-select" v-model="provinciaResidenzaSelezionata" :options="provinciaResidenzaOptions" @change="onChangeProvinciaResidenza" value-field="value" text-field="label">
            <template #first>
              <b-form-select-option :value="null" disabled>Seleziona la provincia di residenza</b-form-select-option>
            </template>
          </b-form-select>
        </b-col>
        <b-col sm>
					<label for="select-comuneresidenza">Comune di residenza</label>
          <b-form-select
						id="select-comuneresidenza"
            class="form-select"
            v-model="assistito.istatComuneResidenza"
            value-field="codiceIstat"
            :disabled="selectComuniDisabled"
            :options="comuneResidenzaOptions"
            text-field="descrizione">
            <template #first>
              <b-form-select-option :value="null" disabled>Seleziona il comune di residenza</b-form-select-option>
            </template>
          </b-form-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm class="mt-5">
					<label for="input-cellulare">Numero cellulare</label>
          <b-form-input
						id="input-cellulare"
            type="text"
            class="form-control form-control-solid"
            value=""
            required
            maxlength="10"
            :state="validationCellulare"
            v-model="assistito.telefono"></b-form-input>
        </b-col>
        <b-col sm class="mb-7 mt-5">
					<label for="input-email">Email</label>
          <b-form-input
						id="input-email"
            type="email"
            class="form-control form-control-solid"
            name="email"
            v-model.trim="assistito.email"
            :state="validationEmail"
            @keydown.space.prevent></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="text-end">
          <b-form-checkbox id="checkbox-1" size="md" v-model="terminiServizioAccettati" name="checkbox-1" :value="true" :unchecked-value="false">
          <span class="ml-2">
            Prima di continuare accettare
            <a :href="linkTerminiServizio" target="_blank" class="link-termini">termini e condizioni</a></span
          >
          </b-form-checkbox>
        </b-col>
      </b-row>
    </div>
    <div class="my-5 container card_container">
      <modal-cambia-data-disp :data="now" @getData="getData"></modal-cambia-data-disp>
      <h3 class="mb-5 titolo"><i class="fas fa-clipboard-list"></i> disponibilità</h3>
      <b-row>
        <b-col cols="6">
          <b-button v-b-modal.modal-5 variant="outline-primary" class="mb-5 ml-5" ><i class="fas fa-calendar-plus"></i> Cambia data disponibilità</b-button>
        </b-col>
      </b-row>
      <b-row v-if="prestazionePrimaDisponibilita.length > 0">
        <b-col sm class="mb-7">
          <span class="text-primary">Attività</span><br />
          <span>{{ prestazionePrimaDisponibilita[0].proposta.desPrestazione }}</span>
        </b-col>
        <b-col sm class="mb-7">
          <span class="text-primary">Luogo</span><br />
          <span>{{ prestazionePrimaDisponibilita[0].proposta.reparto.desReparto }}</span>
        </b-col>
        <b-col sm class="mb-7">
          <span class="text-primary">Giorno appuntamento</span><br />
          <span>{{ prestazionePrimaDisponibilita[0].proposta.data }}</span>
        </b-col>
        <b-col sm class="mb-7">
          <span class="text-primary">Importo</span><br />
          <span>{{ prestazioneSelezionata.importo}} €</span>
        </b-col>
      </b-row>
      <span class="text-primary" style="font-size: large">Seleziona Orario</span><br />
			<b-row>
				<b-col v-for="(proposta,index) in prestazionePrimaDisponibilita" :key="index" xs="12" sm="12" md="4" lg="3" class="text-center">
					<b-form-checkbox :disabled="proposta.proposta.slotLiberi === 0" button button-variant="outline-primary" v-model="proposta.proposta.checked" size="lg" class="checkbox-disponibilita" @change="deselect(index)">
						{{proposta.proposta.ora}} disponibili: {{proposta.proposta.slotLiberi}}
					</b-form-checkbox>
				</b-col>
			</b-row>
      <b-container class="bv-example-row mt-10">
        <b-row>
          <b-col>
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
              <b-button variant="outline-primary" :disabled="disponibilitaSelezionata == null" class="mb-5" @click="onConfermaDisponibilita"><i class="fas fa-clipboard-check"></i> Conferma</b-button>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#00388C" loader="dots" :height="120" :width="120"></loading>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import UtilityMixin from "../../utilities/utilityMixin";
import ModalCambiaDataDisp from "../modal/modalCambiaDataDisp.vue";
import PrenotazioniPrivate from "@/services/PrenotazioniPrivate";
import {DateTime} from "luxon";
import Utils from "@/services/Utils";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  mixins: [UtilityMixin],
  components: {
    Loading,
    ModalCambiaDataDisp,
		DatePicker
  },
  data() {
    return {
      showModal: false,
      dataNascita: '',
      assistito: {
        nome: '',
        cognome: '',
				dataNascita: null,
        istatComuneResidenza: null,
        email: '',
        telefono: '',
        codiceFiscale: ''
      },
			dataNascitaMaxDate: new Date(),
      isLoading: false,
      selectComuniDisabled: true,
      provinciaResidenzaOptions: [],
      comuneResidenzaOptions: [],
      provinciaResidenzaSelezionata: null,
      prestazioneSelezionata: {},
      prestazionePrimaDisponibilita: [],
      disponibilitaSelezionata: null,
      visita: 'VISITA GUIDATA',
      linkTerminiServizio: "/resources/terminiServizio/privacy-visitatori.pdf",
      terminiServizioAccettati: false,
      now: [{proposta: { data: DateTime.local().toFormat('dd/MM/yyyy') }}]
    };
  },
  mounted: function () {
    this.recuperaPrestazione();
    this.loadListaProvince();
  },
  methods: {
    recuperaPrestazione() {
      let me = this;
      me.isLoading = true;
      PrenotazioniPrivate.ricercaPrestazione(process.env.VUE_APP_CODICE_STRUTTURA, me.visita.toUpperCase(), undefined)
        .then(response => {
          if(response.data.error) {
            this.isLoading = false;
            this.$bvModal
              .msgBoxOk(response.data.msg, {
                title: "Errore",
                size: "md",
                okVariant: "outline-danger",
                headerClass: "vv-msg-header-danger",
                footerClass: "p-2 border-top-0",
                centered: true,
                okTitle: "Chiudi",
              })
              .then()
              .catch();
          } else {
            me.prestazioneSelezionata = response.data.data[0];
            this.getData();
          }
        })
        .catch(() => {
          this.isLoading = false;
          this.$bvModal
            .msgBoxOk('Si è verificato un errore nel recuperare l\'attività. Riprova più tardi.', {
              title: "Errore",
              size: "md",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
              okTitle: "Chiudi",
            })
            .then()
            .catch();
        });
    },
    loadListaProvince() {
      let me = this;
      Utils.getProvince()
        .then(response => {
          if(!response.data.error){
            me.provinciaResidenzaOptions = response.data.data;
          }
        })
        .catch();
    },
    onChangeProvinciaResidenza(value) {
      let me = this;
      me.isLoading= true;
      me.comuniResidenzaOptions = [];
      me.assistito.istatComuneResidenza = null;
      Utils.getComuni(value, null)
        .then(response => {
          if (!response.data.error) {
            me.comuneResidenzaOptions = response.data.data;
            me.selectComuniDisabled = false;
          }
        })
        .catch()
        .finally(() => me.isLoading = false);
    },
    getDisponibilitaSelezionata(disponibilita) {
      this.disponibilitaSelezionata = disponibilita;
    },
    deselect(index) {
      const list = [...this.prestazionePrimaDisponibilita]
      for (let i = 0; i<list.length; i++){
        if(i !== index){
          list[i].proposta.checked = false
        }
      }
      this.prestazionePrimaDisponibilita = list
      if(this.prestazionePrimaDisponibilita[index].proposta.checked){
        this.getDisponibilitaSelezionata(this.prestazionePrimaDisponibilita[index])
      } else {
        this.getDisponibilitaSelezionata(null)
      }
    },
    getData(data = null) {
      let me = this;
      me.isLoading = true;
      const body= {
        codprest: me.prestazioneSelezionata.codprest,
        codunitaop: me.prestazioneSelezionata.codunitaop,
        codreparto: me.prestazioneSelezionata.codreparto,
        desbprest: me.prestazioneSelezionata.desbprest,
        desbunitaop: me.prestazioneSelezionata.desbunitaop,
        dataOrario: data == null ? undefined : `${data} 07:00`
      }
      PrenotazioniPrivate.ricercaPrimaDisponibilita(me.prestazioneSelezionata.codstruttura, body)
        .then(response => {
          if(!response.data.error){
            me.prestazionePrimaDisponibilita = [];
            response.data.data.importo = me.prestazioneSelezionata.importo;
            response.data.data.codstruttura = me.prestazioneSelezionata.codstruttura;
            me.prestazionePrimaDisponibilita = response.data.data;
						console.log(me.prestazionePrimaDisponibilita);
          } else {
            me.$bvModal
              .msgBoxOk(response.data.msg, {
                title: "Errore",
                size: "md",
                okVariant: "outline-danger",
                headerClass: "vv-msg-header-danger",
                footerClass: "p-2 border-top-0",
                centered: true,
                okTitle: "Chiudi",
              })
              .then()
              .catch();
          }
        })
        .catch()
        .finally(() => me.isLoading = false);
    },
    onConfermaDisponibilita() {
      let me = this;
      if (!me.validationNome || !me.validationCognome || !me.validationEmail || !me.validationCodiceFiscale || !me.validationCellulare || !me.validationDataNascita) {
        me.$bvModal
          .msgBoxOk('Compila le informazioni presenti nella sezione Dati visitatore', {
            title: "Dati mancanti",
            size: "md",
            okVariant: "outline-danger",
            headerClass: "vv-msg-header-danger",
            footerClass: "p-2 border-top-0",
            centered: true,
            okTitle: "Chiudi",
          })
          .then()
          .catch();
      } else if (!me.terminiServizioAccettati) {
        me.$bvModal
          .msgBoxOk('Per effettuare la prenotazione devi accettare i termini di servizio.', {
            title: "Dati mancanti",
            size: "md",
            okVariant: "outline-danger",
            headerClass: "vv-msg-header-danger",
            footerClass: "p-2 border-top-0",
            centered: true,
            okTitle: "Chiudi",
          })
          .then()
          .catch();
      } else {
        me.$bvModal.msgBoxConfirm(
          'Sei sicuro di voler prenotare per la disponibilità scelta?',
          {
            title: "Conferma",
            footerClass: "p-2",
            centered: true,
            okTitle: "Si",
            cancelTitle: 'No',
            noCloseOnBackdrop: true,
            noCloseOnEsc: true
          }
        )
          .then(value => {
            if (value)
              me.confermaPrenotazione();
          })
          .catch();
      }
    },
    confermaPrenotazione() {
      let me = this;
      me.isLoading = true;
      const body = {
        codiceFiscale: me.assistito.codiceFiscale.toUpperCase(),
        idTransazione: me.disponibilitaSelezionata.proposta.idTransazione,
        codPrestazione: me.disponibilitaSelezionata.proposta.codPrestazione,
        desPrestazione: me.disponibilitaSelezionata.proposta.desPrestazione,
        data: me.disponibilitaSelezionata.proposta.data,
        ora: me.disponibilitaSelezionata.proposta.ora,
        dataFine: me.disponibilitaSelezionata.proposta.dataFine,
        oraFine: me.disponibilitaSelezionata.proposta.oraFine,
        nota: me.disponibilitaSelezionata.proposta.nota,
        nomeMedico: me.disponibilitaSelezionata.proposta.nomeMedico,
        importo: me.prestazioneSelezionata.importo,
        reparto: {
          codUnitaOp: me.disponibilitaSelezionata.proposta.reparto.codUnitaOp,
          desReparto: me.disponibilitaSelezionata.proposta.reparto.desReparto,
          desUnitaOp: me.disponibilitaSelezionata.proposta.reparto.desUnitaOp,
          codReparto: me.disponibilitaSelezionata.proposta.reparto.codReparto,
          ubicazioneReparto: me.disponibilitaSelezionata.proposta.reparto.ubicazioneReparto,
          ubicazioneUnitaOp: me.disponibilitaSelezionata.proposta.reparto.ubicazioneUnitaOp,
          latitudine: me.disponibilitaSelezionata.proposta.reparto.latitudine,
          longitudine: me.disponibilitaSelezionata.proposta.reparto.longitudine,
          importo: me.disponibilitaSelezionata.importo,
        },
        datiCittadino: {
          nome: me.assistito.nome.toUpperCase(),
          cognome: me.assistito.cognome.toUpperCase(),
					dataNascita: me.assistito.dataNascita,
          istatComuneResidenza: me.assistito.istatComuneResidenza,
          email: me.assistito.email,
          telefono: me.assistito.telefono
        }
      }
      PrenotazioniPrivate.confermaDisponibilita(me.prestazioneSelezionata.codstruttura, body)
        .then(response => {
          if(!response.data.error){
            me.$bvModal.msgBoxOk(response.data.data,
              {
                title: "Conferma Prenotazione",
                footerClass: "p-2",
                centered: true,
                okTitle: "Conferma",
                noCloseOnBackdrop: true,
                noCloseOnEsc: true
              })
              .then(() => {
								window.location.reload();
							})
              .catch();
          } else {
            me.$bvModal
              .msgBoxOk(response.data.msg, {
                title: "Errore",
                size: "sm",
                okVariant: "outline-danger",
                headerClass: "vv-msg-header-danger",
                footerClass: "p-2 border-top-0",
                centered: true,
              })
              .then(() => {
              })
              .catch();
          }
        })
        .catch()
        .finally(() => me.isLoading = false);
    },
		disableDataNascita(date) {
			const now = DateTime.local();
			const date2 = DateTime.fromJSDate(date);
			return date2 > now;
		}
  },
  computed: {
    validationCodiceFiscale() {
      // let regexCodiceFiscale = /(^(?:(?:[B-DF-HJ-NP-TV-Z]|[AEIOU])[AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$)|(^(?:STP|ENI)\d{13}$)/i;
			return this.assistito.codiceFiscale.length === 0 ? null : this.assistito.codiceFiscale.length > 0;
    },
    validationNome() {
      if (this.assistito.nome.length === 0)
        return null;
      return this.assistito.nome.length >= 3;
    },
    validationCognome() {
      if (this.assistito.cognome.length === 0)
        return null;
      return this.assistito.cognome.length >= 3;
    },
    validationEmail() {
      let regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return this.assistito.email.length === 0 ? null : regexEmail.test(this.assistito.email);
    },
    validationCellulare() {
      let regexCellulare = /^3\d{8,9}$/;
      return this.assistito.telefono.length === 0 ? null : regexCellulare.test(this.assistito.telefono)
    },
		validationDataNascita() {
			if (this.assistito.dataNascita == null)
				return null;
			return true;
		}
  }
};
</script>
<style>
.checkbox-disponibilita{
margin: 5px;
}
.checkbox-disponibilita input{
  display: none;
}
.btn-check:checked + .btn-outline-primary, .btn-check:active + .btn-outline-primary, .btn-outline-primary:active, .btn-outline-primary.active, .btn-outline-primary.dropdown-toggle.show {
  background-color: #11A7BE;
}
</style>
